import { Pipe, PipeTransform } from '@angular/core';
import { startCase as _startCase, camelCase as _camelCase, isString as _isString } from 'lodash';
@Pipe({
    name: 'licenseName',
})
export class LicenseNamePipe implements PipeTransform {
    transform(licenseType: string): string {
        const id = _isString(licenseType) ? licenseType : '';
        const result = this.getLicenseDescription(id);
        return result;
    }

    getLicenseDescription(licenseType: string): string {
        if (!licenseType) {
            return '';
        }
        switch (licenseType) {
            case 'chargeye.v2.pro':
                return 'ChargEye Pro';
            case 'chargeye.v2.advanced':
                return 'ChargEye Advanced';
            case 'chargeye.v2.basic':
                return 'ChargEye Basic';
            case 'mykempower.v2.core':
                return 'MyKempower';
            case 'chargeye.depot-master':
                return 'Depot Master';
            case 'chargeye.depot-advanced':
                return 'Depot Advanced';
            case 'chargeye.depot-basic':
                return 'Depot Basic';
            case 'chargeye.free-trial':
                return 'Free Trial';
            case 'chargeye.trial':
                return 'Free Trial';
            case 'chargeye.warranty':
                return 'Warranty';
            case 'chargeye.cpo-advanced':
                return 'CPO Advanced';
            case 'chargeye.cpo-basic':
                return 'CPO Basic';
            case 'chargeye.depotmaster':
                return 'Depot Master';
            case 'chargeye.advanced':
                return 'Advanced';
            case 'chargeye.basic-trimmed':
                return 'Basic';
            case 'chargeye.service':
                return 'ChargEye for Service Partners';
            case 'chargeye.oem':
                return 'ChargeEye for OEMs';
            case 'chargeye.loadbalancing':
                return 'Load Balancing';
            case 'chargeye.evtracking':
                return 'EV Tracking';
            case 'chargeye.basic':
                return 'Early Access';
            case 'chargeye.feature-pnc':
                return 'Plug and Charge';
            case 'chargeye.feature-mobile-connectivity':
                return 'Mobile Connectivity';
            case 'chargeye.feature-display-customization':
                return 'Display Customization';
            default:
                return licenseType;
        }
    }
}
